import { render, staticRenderFns } from "./BbvaClientReferences.vue?vue&type=template&id=b39afaf6&scoped=true&"
import script from "./BbvaClientReferences.vue?vue&type=script&lang=js&"
export * from "./BbvaClientReferences.vue?vue&type=script&lang=js&"
import style0 from "./BbvaClientReferences.vue?vue&type=style&index=0&id=b39afaf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39afaf6",
  null
  
)

export default component.exports